import { combineReducers } from 'redux'
import auth from './auth'
import invoices from './invoices'
import currencies from './currencies'
import ui from './ui'
import contractors from './contractors'
import settings from './settings'
import users from './users'
import root from './root'
import companies from './companies'
import files from './files'
import payments from './payments'
import ksef from './ksef'

export const actions = {
  auth: auth.actions,
  invoices: invoices.actions,
  currencies: currencies.actions,
  ui: ui.actions,
  contractors: contractors.actions,
  settings: settings.actions,
  users: users.actions,
  root: root.actions,
  companies: companies.actions,
  files: files.actions,
  payments: payments.actions,
  ksef: ksef.actions,
}

export const selectors = {
  auth: auth.selectors,
  invoices: invoices.selectors,
  currencies: currencies.selectors,
  ui: ui.selectors,
  contractors: contractors.selectors,
  settings: settings.selectors,
  users: users.selectors,
  companies: companies.selectors,
  files: files.selectors,
  payments: payments.selectors,
  ksef: ksef.selectors,
}

export const reducer = combineReducers({
  auth: auth.reducer,
  invoices: invoices.reducer,
  currencies: currencies.reducer,
  ui: ui.reducer,
  contractors: contractors.reducer,
  settings: settings.reducer,
  users: users.reducer,
  companies: companies.reducer,
  files: files.reducer,
  payments: payments.reducer,
  ksef: ksef.reducer,
})
